/**
 * @description 基础api配置对象
 * @author xurui
 * @date 2020/06/11
 */
import axios from './http';
import router from '../../router';

//加密方法
import base64 from '@/utils/base64.js'
import md5 from '@/utils/md5.js'
import jquery from '@/utils/jquery.js'
import CryptoJS from "@/utils/crypto-js.js"
import jsrsasign from 'jsrsasign'

/**
 * 请求相应日志记录
 */

function changeDataType(obj) {
	let str = ''
	if (typeof obj == 'object') {
		for (let i in obj) {
			if (typeof obj[i] != 'function' && typeof obj[i] != 'object') {
				str += i + '=' + obj[i] + '&';
			} else if (typeof obj[i] == 'object') {
				nextStr = '';
				str += changeSonType(i, obj[i])
			}
		}
	}
	return str.replace(/&$/g, '');
}

function deleteEmptyProperty(object) {
	for (var i in object) {
		var value = object[i];
		if (typeof value === 'object') {
			if (Array.isArray(value)) {
				if (value.length == 0) {
					delete object[i];
					console.log('delete Array', i);
					continue;
				}
			}
			deleteEmptyProperty(value);
			if (isEmpty(value)) {
				delete object[i];
			}
		} else {
			if (value === '' || value === null || value === undefined) {
				delete object[i];
				// console.log('delete ', i);
			} else {
				// console.log('check ', i, value);
			}
		}
	}
}

function isEmpty(object) {
	for (var name in object) {
		return false;
	}
	return true;
}

function isRandom() {
	let str = '0123456789';
	let num = '';
	for (let i = 0; i < 21; i++) {
		num += str.charAt(Math.floor(Math.random() * str.length));
	};
	return num;
}

function getNftcnApiSignature(str) {
	//此处操作与后端约定参数
	// 创建RSAKey对象

	var rsa = new jsrsasign.RSAKey();
	//因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
	var k = `-----BEGIN PRIVATE KEY-----
	MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCKHlfkGGiITVyjeE/ITClJhEnsOZif+Xds1sFOsVh2kgvDQKN2Ftuld7BRCnDrXmuZz/jk+6RymFCV1wAW8vE2iWh5Adq1OCUZy8ENOk7Xnn/OhN2GmSiuDPa/rYOyVfD4EUndA0zEPW3lRpzYHosYT/kkxngsVGUmvp9ZCGAKGBwOBlNh//kbNDj5iriENpW+3mq+gdpPcgO5/fE95R6uNn3CgG7WTqL/w/2p2I1fQvgiLtYWhTJUlf4w63CErXMPaeCogZNkiX48D3PKeCEAsei2sF7M3zdny8HOm5gsjipXpA4RYOGQj2VOAfh8l8t4UMCxaz8WZ86Rwz2lr7xVAgMBAAECggEAPCS+bQrb6g6V+nEXfMb9a4/5iK4D8hV1laVmg9fiB6/NA3cQNwn5F3KpCoEbbsKs5EuVvFB/6Y69+KGo3lVoCDGJlrfh/uu17Ce3pwTu9CGG0e01cbkb576pbAoowO1/guY0XdNkCEgfpKk8/zc9ppacjREHn3YYneiABwsIlxwICIA1tzG+xaB+0yigy71tja6ML/os5cJ+/1lt4YOZdTj4HCqxtZISKqjbnAzqiiwwb9Py7grwny5Pi3ZfsoZJtcrz+Ps0MMnDAaG6WexAXisjF8fuonqY1+OUXnF4efKAyB2u0buz0u86G+nTKeG5jNWqaVi3jadBoMfc8lBjuQKBgQDO4FSkEg0ZKa/xuareEpdGBDEKwSVqZEdDZmpP7lG2NfDdhzkDz25XMJsoV6pONS4inp5ilp2Cw/6NfaIM56dWYYiJ09JkCqlwK96dR9RcgKPYheCNRWeRSE6HUnlG2MRpMZR5ufSPPPN2RS0Gu/C40Dd1nAljgWg7WjRLSNQfpwKBgQCq6ldnX9A7JKMdZXKhAuykuUJN5oTZswRi+xsXbQWKOjXTbMn1NLw8skPr+Otkr+olnsuT7+A7/OSZEdGIa5QhfJcjKU0prooHnCRQtaP68oXco1HnpY+yKDRnVlDdxkvyGqVuooBiMtt9QqyV3IZjtYH8WXC0bnQuFVTfys5jowKBgQDNG8uvdBo6dYN1BWFslkAXcjZxdDg1eMDTCWqkXyPypR5vdQ9JQNMkbROYdvpqWf2o410jYDNAoDP0crhFVTQqx77I8BPrjkqZ5VTs2XeqUvyfw3R0fHiHqYn6TwHhBTAPH9IWshDQJ103SLSwtYugoQgreg4w8u+10OSCM+3khwKBgDLMD0okCelqDCiyfA0qp1aV0QUCHD3vnMAmTXj66AibIGBEFwoPsFqByPobMyrrtbWUqoC/bG+ny/FKgHIBNzd0ph7HKa3XuCJm38w1EBWHew2GZNNqO3kBxgFogARJ6Ux9aumk1m9ZGi7yYATyU+bSjV2I35xgr5r6sA0LY6ftAoGAE/HYo6wY+u2MXPLNsEMOOXjO3dvZH46USrs1jmdphcwISLSB2EeOf9hLp6flSYIZMXpBVGaMaSmzJOTk0eCco57LmbTtlQAyUx5j1jxySN4ph2IcO8qb9rJXJ1w1tGW1qSCe5ELJbMrYJH386r4qkD74QWSY6P9M1SgCtJ6vaLM=
	-----END PRIVATE KEY-----`
	// 将密钥转码
	rsa = jsrsasign.KEYUTIL.getKey(k);
	// 创建Signature对象，设置签名编码算法
	var sig = new jsrsasign.KJUR.crypto.Signature({
		"alg": "SHA256withRSA"
	});
	// 初始化
	sig.init(rsa)
	// 传入待加密字符串
	sig.updateString(str)
	// 生成密文
	var sign = jsrsasign.hextob64(sig.sign());
	// 对加密后内容进行URI编码
	//把参数与密文拼接好，返回
	var params = sign;
	return params
}
//排序的函数
function objKeySort(arys) {
	//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
	var newkey = Object.keys(arys).sort();
	//console.log('newkey='+newkey);
	var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
	for (var i = 0; i < newkey.length; i++) {
		//遍历newkey数组
		newObj[newkey[i]] = arys[newkey[i]];
		//向新创建的对象中按照排好的顺序依次增加键值对

	}
	return newObj; //返回排好序的新对象
}

// 不需要处理错误的post 请求url。 目前用在设备管理 导入模板上传 取消！
const noProcessingPostUrl = ['/smart/import/Equipment', '/smart/import/EquipmentClass', '/smart/import/MachineRoom',
	'/smart/import/MachineRoomClass'
];
class BaseApi {
	constructor() {
		this.axios = axios; // 直接使用axios的api
		this.routePathArr = ['/login']; // 需要过滤错误的路由路径
	}
	_doRequest_$1(method = 'get', url, params, config) {
		/**
		 * @description 执行请求$1（get方式）
		 * @param {string} method 指定的请求方式，默认值为"get"
		 * @param {string} url 接口的url
		 * @param {object} params 请求参数
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，值为"-1"时，即不需要提示
		 * @returns {object} promise对象
		 */
		let routePath = router.history.current.fullPath;
		return new Promise((resolve) => {
			axios[method](
				url, {
					params,
				},
				config
			).then((res) => {
				if (![200].includes(res.retCode)) {
					resolve(res);
					if (!this.routePathArr.includes(routePath)) {}

					return;
				}
				if (res.retCode === -103) {
					console.log('登录失效请重新登录');
					localStorage.clear();
					sessionStorage.clear();
					router.push({
						name: 'login',
					});
					return;
				}
				resolve(res);
			});
		});
	}

	_doRequest_$2(method = 'post', url, data, config) {
		/**
		 * @description 执行请求$2（post方式 ｜ put方式 ｜ delete方式）
		 * @param {string} method 指定的请求方式，默认值为"post"
		 * @param {string} url 接口的url
		 * @param {object} data 提交的数据
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，值为"-1"时，即不需要提示
		 * @returns {object} promise对象
		 */
		let routePath = router.history.current.fullPath;
		return new Promise((resolve) => {
			axios[method](url, data, config).then((res) => {
				if (![200].includes(res.retCode)) {
					//  不弹窗提示框
					if (res.retCode === 0 && noProcessingPostUrl.includes(url)) {
						resolve(res);
						return;
					}
					resolve(res);
					if (!this.routePathArr.includes(routePath)) {}
				}
				if (res.retCode === -103) {
					console.log('登录失效请重新登录');
					localStorage.clear();
					sessionStorage.clear();
					router.push({
						name: 'login',
					});
				}
				resolve(res);
			});
		});
	}

	get(url, params = {}, config = {}, successText = '-1') {
		/**
		 * @description get方式
		 * @param {string} url 接口的url
		 * @param {object} params 请求参数
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，默认值为"-1"，即不需要提示
		 * @returns {object} promise对象
		 */
		return this._doRequest_$1('get', url, params, config, successText);
	}

	delete(url, params = {}, config = {}, successText = '-1') {
		/**
		 * @description delete方式
		 * @param {string} url 接口的url
		 * @param {number} id 要删除的记录的id
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，默认值为"-1"，即不需要提示
		 * @returns {object} promise对象
		 */
		return this._doRequest_$1('delete', url, params, config, successText);
	}

	post(url, data = {}, config = {}, successText = '-1') {
		// let key = '103$5bdd*@#(88b*5)1e3fb';
		// let body = $.param(data) //第一步编译转换成string
		// let deta = base64.base64_encryption(md5(body)) //第二步获得Data
		// let sign = base64.base64_encryption(CryptoJS.HmacSHA1(deta, key).toString(CryptoJS.enc.Hex)) //获得sign签名
		// axios.defaults.headers['authorization'] = "Bearer " + localStorage.getItem('token');
		// axios.defaults.headers['Content-Type'] = body;
		// axios.defaults.headers['cache-control'] = sign;
		/**
		 * @description post方式
		 * @param {string} url 接口的url
		 * @param {object} data 提交的数据
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，默认值为"-1"，即不需要提示
		 * @returns {object} promise对象
		 */
		let _this = this
		var nftcnApiAppId, nftcnApiNonce, nftcnApiSignature, nftcnApiAppSecret, nftcnApiTimestamp //声明请求头5个信息
		nftcnApiAppId = 'nftcn-app-web' //写死的参
		nftcnApiTimestamp = new Date().getTime() //时间戳
		nftcnApiNonce = isRandom() //获取随机数
		nftcnApiAppSecret = md5(nftcnApiAppId + nftcnApiNonce).toUpperCase() //md5拼接转换
		//定义
		var map = {
			"nftcnApiAppId": nftcnApiAppId,
			"nftcnApiAppSecret": nftcnApiAppSecret,
			"nftcnApiNonce": nftcnApiNonce,
			"nftcnApiTimestamp": nftcnApiTimestamp,
		}
		Object.assign(map, data)
		deleteEmptyProperty(map); //
		let body = changeDataType(objKeySort(map)) //排序
		// let body = $.param(function_tools.objKeySort(map))
		nftcnApiSignature = getNftcnApiSignature(body)
		axios.defaults.headers["Authorization"] = localStorage.getItem('token') //自定义请求头信息
		axios.defaults.headers["nftcnApiTimestamp"] = nftcnApiTimestamp
		axios.defaults.headers["nftcnApiNonce"] = nftcnApiNonce
		axios.defaults.headers["nftcnApiSignature"] = nftcnApiSignature
		axios.defaults.headers["nftcnApiAppId"] = nftcnApiAppId
		axios.defaults.headers["nftcnApiAppSecret"] = nftcnApiAppSecret
		console.log(url)
		return this._doRequest_$2('post', url, data, config, successText);
	}
	post_java(url, data = {}, config = {}, successText = '-1') {
		// axios.defaults.baseURL = "/nms/dubbo/"
		let _this = this
		var nftcnApiAppId, nftcnApiNonce, nftcnApiSignature, nftcnApiAppSecret, nftcnApiTimestamp //声明请求头5个信息
		nftcnApiAppId = 'nftcn-app-web' //写死的参
		nftcnApiTimestamp = new Date().getTime() //时间戳
		nftcnApiNonce = isRandom() //获取随机数
		nftcnApiAppSecret = md5(nftcnApiAppId + nftcnApiNonce).toUpperCase() //md5拼接转换
		//定义
		var map = {
			"nftcnApiAppId": nftcnApiAppId,
			"nftcnApiAppSecret": nftcnApiAppSecret,
			"nftcnApiNonce": nftcnApiNonce,
			"nftcnApiTimestamp": nftcnApiTimestamp,
		}
		Object.assign(map, data)
		deleteEmptyProperty(map); //
		let body = changeDataType(objKeySort(map)) //排序
		// let body = $.param(function_tools.objKeySort(map))
		nftcnApiSignature = getNftcnApiSignature(body)
		axios.defaults.headers["Authorization"] = localStorage.getItem('token') //自定义请求头信息
		axios.defaults.headers["nftcnApiTimestamp"] = nftcnApiTimestamp
		axios.defaults.headers["nftcnApiNonce"] = nftcnApiNonce
		axios.defaults.headers["nftcnApiSignature"] = nftcnApiSignature
		axios.defaults.headers["nftcnApiAppId"] = nftcnApiAppId
		axios.defaults.headers["nftcnApiAppSecret"] = nftcnApiAppSecret
		console.log(url)
		return this._doRequest_$2('post', url, data, config, successText);
	}
	put(url, data = {}, config = {}, successText = '-1') {
		/**
		 * @description put方式
		 * @param {string} url 接口的url
		 * @param {object} data 提交的数据
		 * @param {object} config 请求配置（config.headers）
		 * @param {string} successText 请求成功提示的信息，默认值为"-1"，即不需要提示
		 * @returns {object} promise对象
		 */
		return this._doRequest_$2('put', url, data, config, successText);
	}
	// 格式化时间
	filterDate() {
		const date = new Date();
		const year = date.getFullYear().toString();
		const month = (date.getMonth() + 1).toString();
		const day = date.getDate().toString();
		const hour = date.getHours().toString();
		const min = date.getMinutes().toString();
		const sec = date.getSeconds().toString();
		return year + month + day + hour + min + sec;
	}
	downLoadFile(url, data = {}) {
		/**
		 * @description 导出下载文件
		 * @param {string} url 接口的url
		 * @param {object} data 提交的数据
		 * @param {object} fileName 文件名称
		 */
		const fileName = this.filterDate();
		axios({
				method: 'get',
				url: url,
				params: data,
				responseType: 'blob',
			})
			.then((res) => {
				let url = window.URL.createObjectURL(new Blob([res]));
				let link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				link.setAttribute('download', fileName + '.csv');
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			})
			.catch((_err) => {
				return _err;
			});
	}
	downLoadFilePost(url, data = {}) {
		/**
		 * @description 导出下载文件
		 * @param {string} url 接口的url
		 * @param {object} data 提交的数据
		 * @param {object} fileName 文件名称
		 */
		const fileName = this.filterDate();
		axios({
				method: 'post',
				url: url,
				params: data,
				responseType: 'blob',
			})
			.then((res) => {
				let url = window.URL.createObjectURL(new Blob([res]));
				let link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				link.setAttribute('download', fileName + '.csv');
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			})
			.catch((_err) => {
				return _err;
			});
	}

}


export default BaseApi;
